module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/reports/labor-spending-e4c0d8.png";